import React, {useState} from "react";
import styled from "styled-components";
import Zoomable from "react-instagram-zoom";

const ImageContainer = styled.div`
  background: #fff;
  border-radius: 15px;
  width: ${props => props.portrait ? "fit-content" : "100%"};
  margin: ${props => props.portrait ? "0 auto" : "auto"};
`;
const StyledImage = styled.img`
  border-radius: 15px;
  pointer-events: none;
  width: ${props => props.portrait ? "auto" : "100%"};
  height: 222px; 
  object-fit: ${props => props.portrait ? "contain" : "cover"};

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakSmall}) {
    height: 306px;
  }

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
    height: 420px;
  }
`;
const ImageDescription = styled.div`
  background: #F0F0F0;
  width: 100%;
  color: #0f0538;
  font-size:14px;
  text-align:left;
  font-weight: 500;
  border-radius: 15px;
  margin:5px 0 5px 0; 
  padding: 12px 27px 12px 27px;

@media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakSmall}) {
    font-size:18px;
  }

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
    font-size:22px;
  }
`;

function Image({data, isImageZoomed}) {

 const [portrait, setPortrait] = useState(0);

  const handleImageLoadFail = (e) => {
    e.target.src =
      process.env.REACT_APP_AWS_URL +
      "uploads/floorplans/default.png?h=500&w=620&zc=2";
  };

  return (
    <ImageContainer className="ImageContainer" portrait={portrait}>
      <Zoomable
        onTouchStart={() => isImageZoomed(true) }
        onTouchEnd={() => isImageZoomed(false) }
      >
        <StyledImage
          className="StyledImage"
          onError={handleImageLoadFail}
          onLoad={(e) => {return setPortrait(e.target.naturalWidth < e.target.naturalHeight)}}
          portrait={portrait}
          src={data.src.includes("https://")?data.src:(process.env.REACT_APP_AWS_URL + "uploads/images/gallery/" + data.src)+ "?h=500&w=620&zc=1"}
          alt={"gallery item"}
        />
      </Zoomable>
	 {data.description && (
	   <ImageDescription className="ImageDescription"> 
         <span>{data.description}</span>
       </ImageDescription>	
	  )}
    </ImageContainer>   
  );	
}
export default Image;
